import React from 'react';
import './branchpred.css';
import CodeEditor from '../codeeditor';
import { Icon, Button } from '@blueprintjs/core';
import codeManager from '../codemanager';
import SolutionPanel from '../solutionpanel';
import Flowchart from 'react-simple-flowchart';
import _ from 'lodash';

export default class BranchPrediction extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
                        code: "",
                        flowChart: "",
                        instrList: []
                    };
        this.handleNewCode = this.handleNewCode.bind(this);
        this.chartOpts = {
            'scale': 0.8,
        };
        this.onThemeChanged = this.onThemeChanged.bind(this);
    }

    componentDidMount() {
        this.handleNewCode();
        document.addEventListener("themeChange", this.onThemeChanged);
    }

    componentWillUnmount() {
        document.removeEventListener("themeChange", this.onThemeChanged);
    }

    onThemeChanged(event) {
        this.forceUpdate();
    }

    handleNewCode() {
        const code = codeManager.getRandomCodeForBranchPrediction();
        const parsedCode = codeManager.parseCode(code);


        this.setState({code: code, instrList: parsedCode, jumps: [], error: ""}, () => this.processNewCode());
    }

    processNewCode() {

        let fcCode = "st=>start: Begin\ne=>end: End\n";
        this.state.instrList.forEach((c, ix) => {
            if (c.error === "") {
                if (c.type !== "jump")
                    fcCode += `op${ix}=>operation: ${c.code}\n`;
                else
                    fcCode += `op${ix}=>condition: ${c.regA} ${c.aluOp} 0?\n`;
            }
        });
        fcCode += "st";
        this.state.instrList.forEach((c, ix) => {
            if (c.error === "") {               
                if (c.type !== "jump")
                    fcCode += `->op${ix}`;
                else
                    fcCode += `->op${ix}(no,bottom)`;
            }
        });
        fcCode += "->e\n";
        const dirs = ["left", "right"];
        let d = 0;
        this.state.instrList.forEach((c, ix) => {
            if (c.error === "" && c.type === "jump") {
                fcCode += `op${ix}(yes,${dirs[d]})->op${ix+c.imm/4}\n`;
                d = (d + 1) % 2;
            }
        });        
        console.log(fcCode);    
        const [jumps, error] = this.firstJumps(12);
        console.log(jumps);
        this.setState({flowChart: fcCode, jumps: jumps, error: error});
    }

    firstJumps(jumpNum) {

        function exec(op, a, b) {
            let res;
            if (op === "+")
                res = a + b;
            else if (op === "-")
                res = a - b;
            else if (op === "*")
                res = a * b;
            else if (op === "/")
                res = a / b;
            return res === NaN ? undefined : res;
        }

        function compare(op, a) {
            let res;
            if (op === ">")
                res = a > 0;
            else if (op === ">=")
                res = a >= 0;
            else if (op === "<")
                res = a < 0;
            else if (op === "<=")
                res = a <= 0;
            else if (op === "==")
                res = a == 0;
            else if (op === "!=")
                res = a != 0;
            return isNaN(res) ? undefined : res;
        }
        const jmp = [];
        let pc = 0;
        const regFile = {};
        const memFile = {};
        for(let i=0; i<1000; i++) {
            const instr = this.state.instrList[pc];
            let npc = 4;
            if (instr.type === "int" || instr.type === "float") {
                if (!instr.regA && !instr.regB)
                    regFile[instr.targetReg] = instr.imm;
                else if (!instr.regB)
                    regFile[instr.targetReg] = exec(instr.aluOp, regFile[instr.regA], instr.imm);
                else
                    regFile[instr.targetReg] = exec(instr.aluOp, regFile[instr.regA], regFile[instr.regB]);
            }
            else if (instr.type === "mem" && instr.subType === "store") {
                if (!instr.regA)
                    memFile[instr.imm] = regFile[instr.regB];
                else
                   memFile[exec(instr.aluOp, regFile[instr.regA], instr.imm)] = regFile[instr.regB];
            }
            else if (instr.type === "mem" && instr.subType === "load") {
                if (!instr.regA)
                    regFile[instr.targetReg] = memFile[instr.imm];
                else
                    regFile[instr.targetReg] = memFile[exec(instr.aluOp, regFile[instr.regA], instr.imm)];
            }
            else if (instr.type === "jump" && instr.subType === "direct")
                npc = instr.imm;
            else if (instr.type === "jump" && instr.subType === "indirect")
                npc = regFile[instr.regB];
            else if (instr.type === "jump" && instr.subType === "conditional/direct" && compare(instr.aluOp, regFile[instr.regA]))
                npc = instr.imm;         
            else if (instr.type === "jump" && instr.subType === "conditional/indirect" && compare(instr.aluOp, regFile[instr.regA]))
                npc = regFile[instr.regB];
            if (instr.type === "jump")
                jmp.push({pc: pc, dir: npc===4 ? "NT" : "T"});
            pc = pc + npc / 4;
            if (pc >= this.state.instrList.length || jmp.length >= jumpNum)
                return [jmp, ""];
        }
        return [[], `Az első 1000 utasítás végrehajtása után sem volt a kódban ${jumpNum} ugrás!`];
    }

    renderLoopProps() {
        return <div className="branchpred-loopprops-table-container"><table className="branchpred-loopprops-table">
            <thead>
                <tr><th></th>{this.state.jumps.map((a,ix) => <th key={ix}>{ix+1}. ugrás</th>)}</tr>
            </thead>
            <tbody>
            <tr><td>Ugrás sora:</td>{this.state.jumps.map((a,ix) => <td key={ix}>{a.pc}</td>)}</tr>
            <tr><td>Ugrás kimenetele:</td>{this.state.jumps.map((a,ix) => <td key={ix}>{a.dir}</td>)}</tr>
            </tbody>
        </table></div>
    }

    render() {

        let error = <></>;
        if (this.state.instrList && this.state.instrList.some(x => x.error.length > 0)) {
            error = <div className="code-error-area">
                {this.state.instrList.filter(x => x.error.length > 0).map((instr, ix) =>
                    <div key={ix}><Icon icon="error"/>&nbsp;{`line ${instr.line}: ${instr.error}`}</div>)}
            </div>
        }

        this.chartOpts["line-color"] = getComputedStyle(document.querySelector('body')).getPropertyValue("--main-fg-color");
        this.chartOpts["element-color"] = getComputedStyle(document.querySelector('body')).getPropertyValue("--main-fg-color");
        this.chartOpts["fill"] = getComputedStyle(document.querySelector('body')).getPropertyValue("--main-bg-color");
        this.chartOpts["font-color"] = getComputedStyle(document.querySelector('body')).getPropertyValue("--main-fg-color");

        return (
            <>
                <div className="title-area">
                    <h1>Elágazásbecslés (Work in progress)</h1>
                    <h2>Az elágazások kimenetelének becslése</h2>
                </div>
                <div className="demo-emph-row">
                    <div className="branchpred-top-row-left-col">
                        <h3>Utasítássorozat:</h3>
                        <CodeEditor 
                            code={this.state.code} 
                            onChange={instrList => this.setState({instrList: instrList}, () => this.processNewCode())} 
                        />
                        <Button 
                            icon="refresh"
                            text="Másik generálása"
                            className="branchpred-generate-button"
                            onClick={this.handleNewCode} 
                        />
                    </div>
                </div>
                {error}
                <div>
                    <h3>1. Feladat</h3>
                    <p>Rajzoljuk le az algoritkus folyamatábráját!</p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása">
                        <div className="demo-emph-row">
                        <div className="branchpred-flowchart-panel">
                            {this.state.flowChart?.length > 0 && <Flowchart
                                chartCode={this.state.flowChart}
                                options={this.chartOpts}
                            />}
                        </div>                            
                        </div>
                    </SolutionPanel>
                </div>
                <div>
                    <h3>2. Feladat</h3>
                    <p>Adjuk meg az első 12 ugrás címét (a forráskódbeli sor számával) és kimenetelét (T=történt ugrás, NT=nem történt ugrás)!</p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása">
                        <div className="demo-emph-row">
                            {this.state.error!=="" && <>Hibás ciklus</>}
                            {this.state.error==="" && this.renderLoopProps()}
                        </div>
                    </SolutionPanel>
                </div>
           </>
        );
    }
}